// extracted by mini-css-extract-plugin
export default {"productDescription":"_--z","featuredDescription":"a_-z","description":"b_-z","more":"c_-z","descriptionSku":"d_-z"};